import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const WhyChooseUsPage = lazy(() => import('../pages/why-choose-us/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PackagesPage = lazy(() => import('../pages/packages/page'));
const FreeAssessmentPage = lazy(() => import('../pages/free-assessment/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/why-choose-us',
    element: <WhyChooseUsPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/packages',
    element: <PackagesPage />,
  },
  {
    path: '/free-assessment',
    element: <FreeAssessmentPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
